import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { CheckCircle2, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function BillingSuccess() {
  const nav = useNavigate();
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    let tries = 0;
    let t;
    const poll = async () => {
      try {
        const { data } = await api.get("/billing/status");
        if (data.is_active) { setStatus("active"); return; }
        tries += 1;
        if (tries >= 15) { setStatus("pending"); return; }
        t = setTimeout(poll, 2000);
      } catch { setStatus("error"); }
    };
    poll();
    return () => clearTimeout(t);
  }, []);

  return (
    <div className="min-h-screen bg-[#FAF7F2] grid place-content-center p-6">
      <div className="max-w-md bg-white rounded-3xl border border-[#E5DCCE] p-8 text-center shadow-sm">
        <div className={`w-16 h-16 rounded-full grid place-content-center mx-auto ${
          status === "active" ? "bg-emerald-100 text-emerald-600" : "bg-amber-100 text-amber-700"
        }`}>
          {status === "active" ? <CheckCircle2 className="w-8 h-8"/> : <Sparkles className="w-8 h-8 animate-pulse"/>}
        </div>
        <h1 className="font-display text-3xl font-bold mt-4">
          {status === "checking" && "Setting up your trial…"}
          {status === "active" && "You're all set!"}
          {status === "pending" && "Almost there…"}
          {status === "error" && "Hmm, something's off"}
        </h1>
        <p className="text-sm text-[#6B625B] mt-2">
          {status === "checking" && "Confirming with Stripe"}
          {status === "active" && "Your 7-day free trial has started. No charge for 7 days."}
          {status === "pending" && "Stripe is still finalising. Refresh in a moment."}
          {status === "error" && "Please refresh or contact support."}
        </p>
        <Button onClick={() => nav(status === "active" ? "/groomer" : "/billing")}
          className="mt-6 rounded-full bg-[#C85A17] hover:bg-[#A9480F] btn-tactile"
          data-testid="btn-success-continue">
          {status === "active" ? "Open dashboard" : "Back to billing"}
        </Button>
      </div>
    </div>
  );
}
